// extracted by mini-css-extract-plugin
export default {"collaborativeDisplay-outContent":"collaborativeDisplay-outContent--kQzSW","iconArrowRight":"iconArrowRight--BFDLz"};